import React from 'react'

import { TbH1 } from 'react-icons/tb'

import { useIntl } from '@app/intl/Intl'
import { BlockButton } from '@app/lib/inputs/RichEditor/blocks/BlockButton'
import { TextElementType } from '@app/lib/inputs/RichEditor/types'

export const HeadingOneButton = () => {
  const { formatMessage } = useIntl()

  return (
    <BlockButton
      format={TextElementType.HeadingOne}
      icon={<TbH1 />}
      aria-label={formatMessage({ id: 'RichEditor.Element.HeadingOne' })}
    />
  )
}
